import { RoutePaths } from "../../models";
export { UNDERWRITING_UI_EMBED_PAGES } from "../../models/underwritingUi";

export const UNDERWRITING_UI_ROUTE_PATHS = {
  POLICIES: RoutePaths.UNDERWRITING_UI_POLICIES,
  POLICY_COMPARE: RoutePaths.UNDERWRITING_UI_POLICY_COMPARE,
  POLICY_SIMULATE: RoutePaths.UNDERWRITING_UI_POLICY_SIMULATE,
  EXECUTION_DETAIL: RoutePaths.UNDERWRITING_UI_EXECUTION_DETAIL,
} as const;

export function buildUnderwritingUiPolicyDetailUrl(policyName: string) {
  return `${UNDERWRITING_UI_ROUTE_PATHS.POLICIES}/${encodeURIComponent(
    policyName
  )}`;
}

export function buildUnderwritingUiExecutionUrl(executionId: string) {
  return UNDERWRITING_UI_ROUTE_PATHS.EXECUTION_DETAIL.replace(
    ":executionId",
    encodeURIComponent(executionId)
  );
}

export function buildUnderwritingUiPolicyCompareUrl(base: string, target: string) {
  const searchParams = new URLSearchParams({ base, target });
  return `${UNDERWRITING_UI_ROUTE_PATHS.POLICY_COMPARE}?${searchParams.toString()}`;
}
